module.exports = __webpack_public_path__ + "img/haze_kushkings.gm.bce02ed.png";